import React from 'react'

const Logo = ({ variant = 'nav' }) => {
  if (variant === 'footer') {
    return (
      <div className="agents-logo agents-logo--footer">
        <span className="agents-logo__uh">
          <span className="agents-logo__u">U</span>
          <span className="agents-logo__h">H</span>
        </span>
        <span className="agents-logo__name">Urban Hive</span>
      </div>
    )
  }

  return (
    <a href="#top" className="agents-logo agents-logo--nav">
      <span className="agents-logo__uh">
        <span className="agents-logo__u">U</span>
        <span className="agents-logo__h">H</span>
      </span>
      <span className="agents-logo__tagline">
        Urban
        <br />
        Hive
      </span>
    </a>
  )
}

export default Logo
